import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["tabs"];
import clsx from "clsx";
import React, { useCallback, useState } from "react";
import { createMemoClass } from "../create-memo-class";
import { Image } from "./image";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var Tabs = props => {
  var {
    tabs
  } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var [selected, setSelected] = useState(null);
  var select = useCallback(index => {
    setSelected(selected === null ? index : selected === index ? null : index);
  }, [selected]);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx("div", _extends({
      className: "flex flex-col md:flex-row w-full flex-wrap"
    }, rest, {
      children: tabs && tabs.map(tab => /*#__PURE__*/_jsx(Tab, {
        _uid: tab._uid,
        select: select,
        selected: selected,
        image: tab.image,
        title: tab.title,
        description: tab.description,
        content: tab.content,
        tabsCount: tabs.length
      }, tab._uid))
    }))
  });
};
export var Tab = props => {
  var {
    image,
    title,
    description,
    content,
    selected,
    select,
    _uid,
    tabsCount
  } = props;
  var tabClassName = useTabClass({
    tabsCount
  });
  var tabContentClassName = useTabContentClass({
    _uid,
    selected
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: tabClassName,
      onClick: () => select(props._uid),
      children: /*#__PURE__*/_jsxs("div", {
        className: tabContentClassName,
        children: [/*#__PURE__*/_jsxs("div", {
          children: [image && /*#__PURE__*/_jsx(Image, {
            image: image,
            aspect: "landscape"
          }), title && /*#__PURE__*/_jsx("h3", {
            className: "px-3",
            children: title
          }), description && /*#__PURE__*/_jsx("div", {
            className: "px-3",
            children: description
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex items-center mt-4 px-3 pb-3",
          children: [/*#__PURE__*/_jsx("div", {
            className: "inline-block w-3 h-3 mr-2",
            children: /*#__PURE__*/_jsx("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              className: "transform duration-300 ease-in-out " + (selected === _uid ? "rotate-180" : ""),
              fill: "none",
              viewBox: "0 0 20 20",
              stroke: "currentColor",
              children: /*#__PURE__*/_jsx("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                d: "M19 9l-7 7-7-7"
              })
            })
          }), selected === _uid ? 'close' : 'more']
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: clsx("grow  md:order-last min-w-full px-1", selected === props._uid ? "h-auto" : "h-0 hidden"),
      children: /*#__PURE__*/_jsx("div", {
        className: "bg-[#e1e1d7] p-3",
        children: content
      })
    })]
  });
};
var useTabClass = createMemoClass(props => {
  var {
    tabsCount
  } = props;
  var widthSizes = ["", "md:w-full", "md:w-1/2", "md:w-1/3", "md:w-1/4", "md:w-1/5", "md:w-1/6"];
  return clsx("grow  w-full  cursor-pointer mt-2  md:mt-0 px-1", widthSizes[tabsCount]);
});
var useTabContentClass = createMemoClass(props => {
  var {
    selected,
    _uid
  } = props;
  return clsx("flex flex-col justify-between h-full border-b-2 ", selected === _uid ? "border-[#e1e1d7] bg-[#e1e1d7]" : "border-ccq-yellow bg-[#eee]");
});
//# sourceMappingURL=tabs.js.map